import * as React from 'react';

import { ITheme } from '@fluentui/react/lib/Styling';

import { AppFullGallery, AppFullGalleryProps, getAppGalleryStyles, getGalleryWidth } from '@1js/acui-gallery';
import { AppThemeConsumer } from '@1js/acui-theme';

import { RibbonTableGalleryButton } from './RibbonTableGalleryButton';
import { RibbonTableStylesGalleryButtonProps } from './RibbonTableGalleryButton.Props';
import {
  getTableStylesFullGalleryButtonStyles,
  getTableStylesFullGalleryStyles,
  tableStylesGalleryButtonWidth,
} from './RibbonTableStylesGallery.styles';
import { TableCellContent } from './RibbonTableStylesPreviewGallery';

export interface RibbonTableStylesFullGalleryProps extends AppFullGalleryProps<RibbonTableStylesGalleryButtonProps> {
  type: 'RibbonTableStylesFullGalleryProps';
}

const RibbonFullTableStylesGalleryButton: React.StatelessComponent<RibbonTableStylesGalleryButtonProps> = React.memo(
  (props: RibbonTableStylesGalleryButtonProps) => {
    const tableStylesFullButtonProps = {
      ...props,
      tableCellContent: TableCellContent,
      getTableStyling: getTableStylesFullGalleryButtonStyles,
      shouldTakeFocus: props.shouldTakeFocus !== undefined ? props.shouldTakeFocus : true,
      title: undefined,
      label: props.title,
      ariaLabel: props.title,
    };

    return <RibbonTableGalleryButton {...tableStylesFullButtonProps} />;
  }
);

export class RibbonTableStylesFullGallery extends React.PureComponent<RibbonTableStylesFullGalleryProps, {}> {
  public render() {
    const { columns, defaultWidth, styles } = this.props;
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppFullGallery
            {...this.props}
            styles={getAppGalleryStyles(theme, getTableStylesFullGalleryStyles(styles))}
            getGalleryButtonComponent={RibbonFullTableStylesGalleryButton}
            defaultWidth={defaultWidth || getGalleryWidth(columns, tableStylesGalleryButtonWidth, styles)}
          />
        )}
      </AppThemeConsumer>
    );
  }
}
